import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Alert,
  Switch,
  FormControlLabel,
  Card,
  CardContent,
  CardHeader,
} from '@mui/material';
import { useAppContext } from '../../context/AppContext';

const SettingsForm = () => {
  const { ragStrategies, selectedStrategy, setSelectedStrategy } = useAppContext();
  
  const [apiEndpoint, setApiEndpoint] = useState('/api/v1');
  const [defaultTopK, setDefaultTopK] = useState(5);
  const [useReasoningByDefault, setUseReasoningByDefault] = useState(true);
  const [success, setSuccess] = useState(null);
  
  const handleSaveSettings = () => {
    // Save settings to localStorage
    localStorage.setItem('Neobot_settings', JSON.stringify({
      apiEndpoint,
      defaultTopK,
      useReasoningByDefault,
      defaultRagStrategy: selectedStrategy,
    }));
    
    setSuccess('Settings saved successfully!');
    
    // Clear success message after 3 seconds
    setTimeout(() => {
      setSuccess(null);
    }, 3000);
  };
  
  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h5" component="h2" gutterBottom>
        Settings
      </Typography>
      <Divider sx={{ mb: 3 }} />
      
      {success && (
        <Alert severity="success" sx={{ mb: 3 }}>
          {success}
        </Alert>
      )}
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Card>
          <CardHeader title="API Settings" />
          <CardContent>
            <TextField
              fullWidth
              label="API Endpoint"
              value={apiEndpoint}
              onChange={(e) => setApiEndpoint(e.target.value)}
              margin="normal"
              helperText="Base URL for API requests"
            />
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader title="RAG Settings" />
          <CardContent>
            <FormControl fullWidth margin="normal">
              <InputLabel id="default-rag-strategy-label">Default RAG Strategy</InputLabel>
              <Select
                labelId="default-rag-strategy-label"
                value={selectedStrategy}
                label="Default RAG Strategy"
                onChange={(e) => setSelectedStrategy(e.target.value)}
              >
                {ragStrategies.map((strategy) => (
                  <MenuItem key={strategy.id} value={strategy.id}>
                    {strategy.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            
            <TextField
              fullWidth
              label="Default Top-K"
              type="number"
              value={defaultTopK}
              onChange={(e) => setDefaultTopK(parseInt(e.target.value) || 5)}
              margin="normal"
              inputProps={{ min: 1, max: 20 }}
              helperText="Default number of chunks to retrieve"
            />
            
            <FormControlLabel
              control={
                <Switch
                  checked={useReasoningByDefault}
                  onChange={(e) => setUseReasoningByDefault(e.target.checked)}
                  color="primary"
                />
              }
              label="Use reasoning loop by default"
              sx={{ mt: 2 }}
            />
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader title="About" />
          <CardContent>
            <Typography variant="body1" paragraph>
              Neobot is a Retrieval-Augmented Generation (RAG) application for neonatology research.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Version: 0.1.0
            </Typography>
          </CardContent>
        </Card>
        
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveSettings}
          sx={{ mt: 2 }}
        >
          Save Settings
        </Button>
      </Box>
    </Paper>
  );
};

export default SettingsForm;
